<template>
  <div class="h-sidebar-contain my-style" ref="sidebarContain" :class="classObject" @mouseenter="sidebarFocus = true"
    @mouseleave="sidebarFocus = false">
    <div class="h-sidebar-menu">
      <div class="h-sidebar-menu-home" @click="handleHome">
        <div class="h-sidebar-menu-home-li" :class="{ 'home-active': homeAboard }">
          <div class="home-item">
            <router-link to="/uc-index">
              <h-icon class="li-first-i" name="u-a-home"></h-icon>
              <span class="li-span">{{ $t("m.i.common.workSpace") }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-sidebar-menu-container">
        <h-menu theme="dark" accordion :active-name="curMenu" :open-names="openMenu" :width="200" @on-select="menuSelect" ref="menuRef">
          <!-- <h-submenu v-for="(item, sIndex) in childRoute" :key="sIndex" :name="item.id">
                <template slot="title">
                    <h-icon name="computer"></h-icon>
                    <span slot="title" class="li-span">{{item.title}}</span>
                </template>
                <h-menu-item v-for="(item, idx) in item.children" :key="idx" :name="item.id">{{item.title}}</h-menu-item>
            </h-submenu> -->
          <sidebar-item :routes="childRoute"></sidebar-item>
        </h-menu>
      </div>
      <div class="h-sidebar-menu-expand" v-if="!isWebType">
        <div class="expandIcon" @click.prevent.stop="expandSiderbar">
          <!-- 展开 -->
          <h-icon name="u-a-menu"></h-icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* mapGetters工具函数会将store中的getter映射到局部计算属性中 */
/* 使用对象扩展操作符把getter混入到computed中 */

import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import { deepClone } from '@common/utils/tools'
import { getChildData } from '@common/entry/getChildData'
import collapseTransition from '@frame/directives/collapse-transition'
import draggable from 'vuedraggable'

const prefixCls = 'list-tab-panel'

export default {
  components: {
    collapseTransition,
    draggable, // 菜单拖动
    SidebarItem,
  },
  data () {
    return {
      prefixCls: prefixCls,
      childRoute: [],
      search: '',
      searchText: '请输入关键词',
      notFoundText: '没有匹配页面',
      menusType: window.sessionStorage.getItem('menusType'),
      curMenu: [],
      isVertiSide: false,
      covertMenu: {},
      showOptions: false,
      // menusType: Cookies.get('menusType'),
      openMenu: [],
      value: '',
      tabActiveIndex: 0,
      collect: [],
      // collectTotal:{},
      collActived: {},
      noSearched: false,
      homeAboard: false,
      tabMaxHeight: 0,
      childRouteData: [],
      dragItemIndex: -1, // 菜单拖动项index,
      scrollTop: 0, // sider滑块 右侧快速选项scrolltop
      scrollViewHeight: 0, //  sider滑块 右侧快速选项可滚动的高度
      sidebarFocus: false,
      sidebarMenuScrollTop: 0,
      isWebType: false,
      isSecondMenuCollect: false,
    }
  },
  computed: {
    ...mapGetters([
      'activeIndex',
      'menusRoot',
      'menusNoRoot',
      'menusShared',
      'searchRoute',
      'sidebar',
      'hasOpened',
      'collectTotal',
      'token',
      'leafTotal',
      'clickItemIndex',
    ]),
    menusRoot: {
      get () {
        return this.$store.state.app.menusRoot
      },
      set (value) {
        this.$store.state.app.menusRoot = value
      },
    },
    isCollapse () {
      return !this.sidebar.opened
    },
    path () {
      return this.$route.meta.id
    },
    isSidebarExpand () {
      return this.sidebar.opened
    },
    classObject () {
      return {
        'h-sidebar-focus': this.sidebarFocus === true,
        'h-sidebar-blur': this.sidebarFocus === false,
        openedSidebar: !this.isCollapse,
      }
    },
  },

  watch: {
    $route: {
      handler (to) {
        this.$nextTick(() => {
          /**
         *根据当前路由，显示导航tab的高亮
         **/
          let curMenu = ''
          let openMenu = []
          this.childRoute.forEach(item => {
            item.children.forEach(v => {
              if (`/${v.id}` === to.path) {
                curMenu = v.id
                openMenu = [item.id]
              }
            })
          })
          this.openMenu = openMenu
          this.curMenu = curMenu
        })
      },
      immediate: true,
      deep: true
    },
    activeIndex () {
      this.computChildRoute()
      this.handleMenuColl()
    },
    tabActiveIndex (val, old) {
      if (this.childRoute && this.childRoute.length - 1 >= old) {
        this.$set(this.childRoute[old], 'isActived', false)
      }
    },
    menusRoot: {
      handler (val, oval) {
        this.computChildRoute()
      },
      deep: true,
    },
    childRouteData: {
      handler (val, oval) {
        this.covertMenu = {}
        this.rebuildMenu(val)
        if (val && val.length > 0) {
          this.childRoute = []
          val.forEach((item, index) => {
            let newItem = deepClone(item)
            // if(oval!==val){
            //   newItem.isShow = false
            // }else{
            //   newItem.isShow = true
            // }
            if (this.clickItemIndex === -1) {
              if (index === 0) {
                newItem.isActived = true
              }
            } else {
              if (index === this.clickItemIndex) {
                newItem.isActived = true
              }
            }
            this.childRoute.push(newItem)
          })
        }
      },
      deep: true,
    },
  },

  methods: {
    allowToscroll (bol, index) {
      let obj = this.$refs[`list-tab-anx-${index}`][0]
      let heightItem = 32
      var hScrollTop = obj.scrollTop // 对象已纵向滚动的距离
      this.scrollViewHeight = obj.scrollHeight // 对象可滚动的高度
      if (bol) {
        obj.scrollTop = hScrollTop + heightItem
      } else {
        obj.scrollTop = hScrollTop - heightItem
      }
      this.scrollTop = obj.scrollTop
    },
    // 鼠标经过菜单显示隐藏可拖动按钮
    showDragColl (index) {
      this.dragItemIndex = index
    },
    hideDragColl () {
      this.dragItemIndex = -1
    },
    // 菜单收藏排序
    dragOrder (id) {
      this.drag = false
      let menuList = []
      if (this.collectTotal) {
        let collectList = this.collectTotal[id]
        collectList.forEach((item, index) => {
          let menu_code = item.id
          let order_no = index + 1
          menuList.push({ menu_code: menu_code, order_no: order_no })
        })
      }
      let param = { menu_list: JSON.stringify(menuList) }
      let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
      let url = '/sortMenuFavoriteByUserId' + '?time=' + new Date().getTime()
      if (isUrlLowercase === 'true') {
        url = url.toLowerCase()
      }
      this.$http.post(window.LOCAL_CONFIG.OMC_GSV + url, param).then((res) => {
        if (res) {
          this.$hMessage.success({
            content: this.$t('m.i.common.orderMenuMsg_1'),
            duration: 3,
            closable: true,
          })
        } else {
          this.$hMessage.error({
            content: this.$t('m.i.common.orderMenuMsg_2'),
            duration: 3,
            closable: true,
          })
        }
      })
    },
    columnsCount (item) {
      let count = 1
      let floor = this.getMaxFloor(item.children)
      let real = 1
      if (item && item.children) {
        real = floor === 1 ? 1 : item.children.length
        item.children.forEach((x) => {
          if (x.is_hidden && x.is_hidden + '' === 'true') {
            real -= 1
          }
        })
        count = real < 4 ? real : 3
      }
      return {
        counts: count < 1 ? 1 : count,
        maxFloor: floor,
        realCount: real,
      }
    },
    classes (item) {
      let temp = this.columnsCount(item)
      let realCountTemp = temp.realCount
      let maxFloorTemp = temp.maxFloor
      return [
        {
          [`${item.id}`]: true,
          [`${prefixCls}-third-col1`]: item.children && maxFloorTemp === 1,
          [`${prefixCls}-fourth-col1`]:
            item.children && realCountTemp === 1 && maxFloorTemp === 2,
          [`${prefixCls}-fourth-col2`]:
            item.children && realCountTemp === 2 && maxFloorTemp === 2,
          [`${prefixCls}-fourth-col3`]:
            item.children &&
            realCountTemp > 2 &&
            realCountTemp < 4 &&
            maxFloorTemp === 2,
          [`${prefixCls}-fifth-col1`]:
            item.children && realCountTemp === 1 && maxFloorTemp === 3,
          [`${prefixCls}-fifth-col2`]:
            item.children && realCountTemp === 2 && maxFloorTemp === 3,
          [`${prefixCls}-fifth-col3`]:
            item.children &&
            realCountTemp > 2 &&
            realCountTemp < 4 &&
            maxFloorTemp === 3,
        },
      ]
    },
    styles (sIndex, id) {
      return {
        top: this.computeTop(sIndex, id),
      }
    },
    computeTop (sIndex, id) {
      let dom = document.getElementsByClassName(id)
      let tabNode = document.getElementsByName(id)
      let menuOffsetTop = 0
      let top = 0
      if (dom && dom.length > 0 && tabNode && tabNode.length > 0) {
        menuOffsetTop = tabNode[0].offsetTop
        if (dom[0].clientHeight + menuOffsetTop > window.innerHeight) {
          if (menuOffsetTop + 40 > window.innerHeight - 30 - 50) {
            top = window.innerHeight - dom[0].clientHeight - 50 - 30
          } else {
            if (menuOffsetTop > dom[0].clientHeight) {
              top = menuOffsetTop - dom[0].clientHeight + 40
            } else {
              top = menuOffsetTop
            }
          }
        } else {
          top = menuOffsetTop
        }
        const clientHeight = dom[0].clientHeight
        if (top + clientHeight + 50 >= window.innerHeight) {
          top = window.innerHeight - clientHeight - 50
        }
        if (this.sidebarMenuScrollTop > 0) {
          top = top - this.sidebarMenuScrollTop + 50
        }
        top = top < 0 ? 0 : top
      }
      this.tabMaxHeight = window.innerHeight - 50 - 100 - 30
      return top + 'px'
    },
    getMaxFloor (treeData) {
      let max = 0
      function each (data, floor) {
        data.forEach((e) => {
          e.floor = floor
          if (floor > max) {
            max = floor
          }
          if (
            e.is_hidden + '' !== 'true' &&
            e.children &&
            e.children.length > 0
          ) {
            each(e.children, floor + 1)
          }
        })
      }
      each(treeData, 1)
      return max
    },
    scrollToView (event, item, sIndex, menuItem) {
      let node = document.getElementById(item.id)
      node.scrollIntoView()
      menuItem.forEach((i, idx) => {
        if (i.id === item.id) {
          this.$set(i, 'scrolled', true)
        } else {
          this.$set(i, 'scrolled', false)
        }
      })
    },
    handleHome () {
      if (this.childRoute[this.tabActiveIndex]) {
        this.$set(this.childRoute[this.tabActiveIndex], 'isActived', false)
      }
      this.homeAboard = !this.homeAboard
    },
    handleSearch (param) {
      let keyCounter = 0
      let flatTree = []
      let data = []
      function flattenChildren (node) {
        node.nodeKey = keyCounter++
        flatTree[node.nodeKey] = node
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => flattenChildren(child))
        }
        return flatTree
      }
      data = flattenChildren(param)
      data.forEach((item) => {
        if (this.search !== '' && item.title.indexOf(this.search) >= 0) {
          this.$set(item, 'searched', true)
          this.$set(item, 'display', 'inline-block')
        } else if (
          this.search !== '' &&
          item.title.indexOf(this.search) === -1
        ) {
          this.$set(item, 'searched', false)
          this.$set(item, 'display', 'none')
        } else {
          this.$set(item, 'searched', false)
          this.$set(item, 'display', 'inline-block')
        }
      })
      this.$nextTick(() => {
        let dom = document.getElementsByClassName('h-menu-searched')
        if (this.search.length > 0) {
          if (dom.length === 0) {
            this.noSearched = true
          } else {
            this.noSearched = false
          }
        } else {
          this.noSearched = false
        }
      })
    },
    compileFlatState (data) {
      let keyCounter = 0
      let flatTree = []
      function flattenChildren (node, flatTree) {
        if (node.has_collect === '1') {
          node.nodeKey = keyCounter++
          flatTree[node.nodeKey] = node
        }
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => flattenChildren(child, flatTree))
        }
      }
      flattenChildren(data, flatTree)
      if (flatTree && flatTree.length > 0) {
        for (let j = 0; j < flatTree.length - 1; j++) {
          for (let i = 0; i < flatTree.length - 1; i++) {
            if (
              parseInt(flatTree[i].collect_order_no) >
              parseInt(flatTree[i + 1].collect_order_no)
            ) {
              let temp = flatTree[i]
              flatTree[i] = flatTree[i + 1]
              flatTree[i + 1] = temp
            }
          }
        }
      }
      return flatTree
    },
    // 左侧菜单栏生成收藏菜单对象
    handleMenuColl () {
      let child = []
      let isMergeMenu = window.LOCAL_CONFIG.isMergeMenu + ''
      if (this.menusRoot.length === 0) return
      // isMergeMenu为true时合并菜单
      if (isMergeMenu === 'true') {
        child = this.menusRoot
      } else {
        // 所有子系统的二级菜单合并
        // this.menusRoot.map((item,index) => {
        //   child = child.concat(item.children)
        // })
        // 优化为只合并第一个子系统的二级菜单，activeIndex变化时，加载对应的子系统二级菜单
        child = this.menusRoot[this.activeIndex].children
      }
      let initData = {}
      if (child) {
        child.forEach((rootNode) => {
          if (rootNode && rootNode.children && rootNode.children.length > 0) {
            initData[rootNode.id] = this.compileFlatState(rootNode)
          }
        })
        this.$store.dispatch('initCollectMenu', deepClone(initData))
      }
      // let temp = window.LOCAL_CONFIG.temp
      // this.$store.dispatch('initCollectMenu', deepClone(temp))
    },
    // 菜单收藏
    collectMenu (box, id) {
      let status = box.has_collect
      // 是否有子菜单
      let hasChildren = 'false'
      if (box && box.children && box.children.length > 0) {
        hasChildren = 'true'
      }
      let temp = status === '0' ? '1' : '0'
      let obj = {
        menuCode: box.id,
        hasChildren: hasChildren,
      }
      let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
      if (temp === '1') {
        // 收藏菜单
        let url = '/insertUserMenuFavorite' + '?time=' + new Date().getTime()
        if (isUrlLowercase === 'true') {
          url = url.toLowerCase()
        }
        this.$http
          .post(window.LOCAL_CONFIG.OMC_GSV + url, obj)
          .then((res) => {
            if (res) {
              this.$hMessage.success({
                content: this.$t('m.i.common.collectMenuMsg_1'),
                duration: 3,
                closable: true,
              })
              // 是否有子菜单
              if (hasChildren === 'true') {
                box.has_collect = '2'
                // 改变上级菜单状态，例如：用户管理
                if (this.childRouteData && this.childRouteData.length > 0) {
                  this.childRouteData[this.activeIndex].children.forEach(
                    (subMenuItem, subIndex) => {
                      if (subMenuItem.id === box.id) {
                        subMenuItem.has_collect = '2'
                      }
                    }
                  )
                }
                // 刷新收藏改变所有子菜单
                if (box && box.children && box.children.length > 0) {
                  box.children.forEach((bItem) => {
                    if (bItem.has_collect !== '1') {
                      this.$store.dispatch('collectMenu', {
                        box: bItem,
                        id: id,
                      })
                    }
                  })
                }
              } else {
                this.$store.dispatch('collectMenu', { box: box, id: id })
              }
            } else {
              this.$hMessage.error({
                content: this.$t('m.i.common.collectMenuMsg_2'),
                duration: 3,
                closable: true,
              })
            }
          })
          .catch((ex) => {
            this.$hMessage.error({
              content: this.$t('m.i.common.netError'),
              duration: 3,
              closable: true,
            })
          })
      } else {
        // 取消菜单收藏
        let cancelurl =
          '/deleteByMenuCodeAndUserId' + '?time=' + new Date().getTime()
        if (isUrlLowercase === 'true') {
          cancelurl = cancelurl.toLowerCase()
        }
        this.$http
          .post(window.LOCAL_CONFIG.OMC_GSV + cancelurl, obj)
          .then((res) => {
            if (res) {
              this.$hMessage.success({
                content: this.$t('m.i.common.collectFailedMenuMsg_1'),
                duration: 3,
                closable: true,
              })
              // 是否有子菜单
              if (hasChildren === 'true') {
                box.has_collect = '0'
                // 改变上级菜单状态，例如：用户管理
                if (this.childRouteData && this.childRouteData.length > 0) {
                  this.childRouteData[this.activeIndex].children.forEach(
                    (subMenuItem, subIndex) => {
                      if (subMenuItem.id === box.id) {
                        subMenuItem.has_collect = '0'
                      }
                    }
                  )
                }
                // 刷新收藏改变所有子菜单
                if (box && box.children && box.children.length > 0) {
                  box.children.forEach((bItem) => {
                    if (bItem.has_collect !== '0') {
                      this.$store.dispatch('collectMenu', {
                        box: bItem,
                        id: id,
                      })
                    }
                  })
                }
              } else {
                this.$store.dispatch('collectMenu', { box: box, id: id })
                // 改变上级菜单状态，例如：用户管理
                if (this.childRouteData && this.childRouteData.length > 0) {
                  this.childRouteData[this.activeIndex].children.forEach(
                    (subMenuItem, subIndex) => {
                      if (subMenuItem.id === box.parent_code) {
                        subMenuItem.has_collect = '0'
                      }
                    }
                  )
                }
              }
            } else {
              this.$hMessage.error({
                content: this.$t('m.i.common.collectFailedMenuMsg_2'),
                duration: 3,
                closable: true,
              })
            }
          })
          .catch((ex) => {
            this.$hMessage.error({
              content: this.$t('m.i.common.netError'),
              duration: 3,
              closable: true,
            })
          })
      }
    },
    tabActived (index, id) {
      this.tabActiveIndex = index
      let status = this.childRoute[index].isActived
      this.$set(this.childRoute[index], 'isActived', !status)
      // this.collect = this.collectTotal[id]
      this.homeAboard = false
      // 合并菜单时，通过切换菜单栏，进行加载不同的子系统模块
      if (window.LOCAL_CONFIG.isMergeMenu) {
        if (!this.hasOpened) {
          getChildData(this.menusRoot[index].id).then((res) => {
            let data = {
              menu: [this.menusRoot[index]],
              asyncRouterMap: res.router,
            }
            this.$store.dispatch('GenerateRoutesByMenus', data).then(() => {
              this.$router.addRoutes(this.$store.getters.addRouters)
            })
          })
        }
      }
    },
    showTab (index, item) {
      if (
        item &&
        item.children &&
        item.children.length > 0 &&
        item.hasOwnProperty('is_hidden')
      ) {
        if (item.children.every((x) => x.is_hidden + '' === 'true')) {
          return false
        }
      }
      if (this.$refs[`list-tab-anx-${index}`]) {
        // 点击二级菜单 判断右侧栏是否出现滚动条  出现滚动条 显示按钮
        let obj = this.$refs[`list-tab-anx-${index}`][0]
        if (obj) {
          this.scrollViewHeight = obj.scrollHeight // 对象可滚动的高度
          this.scrollTop = obj.scrollTop
        }
        this.$store.dispatch('changeItemIndex', index)
      } else {
        this.$store.dispatch('changeItemIndex', -1)
      }
    },
    hideTab (index, item) {
      // if(event.relatedTarget !== null) {
      // doSomeThing()
      // this.$set(this.childRoute[index], 'isShow', false)
      this.$store.dispatch('changeItemIndex', -1)
      // tab隐藏时清空搜索条件
      this.search = ''
      if (item) {
        this.handleSearch(item)
      }
      // }
    },
    expandSiderbar () {
      this.$store.dispatch('ToggleSidebar')
    },
    openThisMenu ($event, box, sIndex) {
      if (this.$router.history.current.path === box.url) {
        return
      }
      if (this.$router.history.current.meta.share_id === box.id) {
        // 公共菜单
        return
      }
      if (!box.url) {
        return
      }
      this.$router.push({ path: box.url })
      this.childRoute[sIndex].isShow = false
      this.hideTab('', null)
    },
    computChildRoute () {
      if (
        this.menusType &&
        this.menusType === '1' &&
        this.menusRoot.length > 0
      ) {
        // 多个子系统
        let isMergeMenu = window.LOCAL_CONFIG.isMergeMenu + ''
        // isMergeMenu为true时合并菜单
        if (isMergeMenu === 'true') {
          let tempRoute = []
          this.menusRoot.forEach((item) => {
            tempRoute = tempRoute.concat(item)
          })
          this.childRouteData = tempRoute
        } else {
          // 不合并菜单
          let mr = this.menusRoot[this.activeIndex]
          if (mr.show_mode) {
            this.childRouteData = this.menusShared.children //
          } else {
            this.childRouteData = mr.children
          }
        }
      } else {
        // 单个系统
        this.childRouteData = this.menusNoRoot
      }
      // if (this.childRoute && this.childRoute.length > 0) {
      //   this.childRoute.forEach((item, index) => {
      //     this.$set(this.childRouteObj, index, {
      //       id: item.id,
      //       title: item.title,
      //       isShow: false,
      //       isActived: false
      //     })
      //   })
      // }
    },
    rebuildMenu (menus) {
      if (menus && menus.length > 0) {
        for (let menu of menus) {
          this.covertMenu[menu.id] = menu.id
          if (menu.children && menu.children.length > 0) { this.rebuildMenu(menu.children) }
        }
      }
    },
    findUp (id) {
      let openid = this.covertMenu[id]
      let openMenu = []
      // while (openid) {
      openMenu.push(openid)
      //   openid = this.covertMenu[openid]
      // }
      return openMenu
    },
    menuSelect (name) {
      this.$router.push(name);
    },
  },
  mounted () {
    this.$nextTick(() => {
      // 进入nexTick
      // let container = document.getElementsByClassName('h-sidebar-menu-container')[0] // 获取滚动条的dom
      // container.addEventListener('scroll', () => {
      //   this.sidebarMenuScrollTop = container.scrollTop
      // })
      if (!this.curMenu.length) {
        let { comName, parentCode } = this.$route.meta
        if (parentCode) {
          this.curMenu = [comName || '']
          this.openMenu = [parentCode]
        }
      }
    })
  },
  created () {
    // 是否支持上级菜单收藏
    let isSecondMenuCollect = window.LOCAL_CONFIG.isSecondMenuCollect + ''
    if (isSecondMenuCollect === 'true') {
      this.isSecondMenuCollect = true
    }
    this.computChildRoute()
    document.addEventListener('click', (e) => {
      if (
        this.$refs.sidebarContain &&
        !this.$refs.sidebarContain.contains(e.target)
      ) {
        this.$store.dispatch('changeItemIndex', -1)
      }
    })
    if (this.childRoute && this.childRoute.length > 0) { this.openMenu = [this.childRoute[0].id] }
    // 兼容IE中路由无法跳转问题
    let that = this
    if (
      '-ms-scroll-limit' in document.documentElement.style &&
      '-ms-ime-align' in document.documentElement.style
    ) {
      // detect it's IE11
      window.addEventListener(
        'hashchange',
        function (event) {
          var currentPath = window.location.hash.slice(1)
          if (that.$route.path !== currentPath) {
            that.$router.push(currentPath)
          }
        },
        false
      )
    }
    // 生成收藏菜单
    this.handleMenuColl()
    // 是否web端登录
    if (this.$myIpcSend.isWebType()) {
      this.isWebType = true
    }
  },
}
</script>
<style  scoped lang="scss">
.my-style /deep/ .h-sidebar-menu-expand {
  z-index: 999;
  position: fixed;
  bottom: 10px;
  width: 200px;
  height: 30px;
  background: #fff;
  cursor: pointer;
}
.lightblue .h-menu-dark {
  background-color: #131520;
  /deep/.h-menu-opened {
    .h-menu {
      background-color: #1c232f !important;
    }
  }
  /deep/.h-menu-item-active {
    .h-menu-submenu-title {
      background-color: #1c232f;
    }
  }
}
.h-sidebar-menu{
  .home-item{
    .li-first-i{
      font-size:14px;
    }
  }
}
</style>
